import type { ThemeChoice } from '../app/theme';
import s from './ui.module.scss';

/**
 * La bascule de theme.
 *
 * Trois etats et non deux, parce que `system` n'est pas « clair par defaut » :
 * c'est « suis mon appareil ». Le bouton l'annonce, sinon un joueur qui vient
 * de passer son telephone en mode nuit croirait le jeu casse.
 */
const LABELS: Record<ThemeChoice, string> = {
  system: 'Auto',
  dark: 'Nuit',
  light: 'Jour',
};

export interface ThemeToggleProps {
  choice: ThemeChoice;
  onCycle: () => void;
}

export function ThemeToggle({ choice, onCycle }: ThemeToggleProps) {
  return (
    <button
      type="button"
      className={s.themeToggle}
      onClick={onCycle}
      aria-label={`Theme : ${LABELS[choice]}. Cliquer pour changer.`}
      title="Theme"
    >
      {LABELS[choice]}
    </button>
  );
}
